var map = {
	"./liftingSinusesLeft.stl": 882715,
	"./liftingSinusesRight.stl": 294187,
	"./lowSinusesLeft.stl": 500401,
	"./lowSinusesRight.stl": 926046,
	"./normalSinusesLeft.stl": 101323,
	"./normalSinusesRight.stl": 455044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670922;